export const EN_CODE = "en";
export const CURRENT_LANGUAGE_CODE = EN_CODE;
